// extracted by mini-css-extract-plugin
var _1 = "RequestProfileTabEmailsTable-moduleRequestProfileTabEmailsTable__BXRTk";
var _2 = "RequestProfileTabEmailsTable-moduleemptyPage__eeFyG";
export { _1 as "RequestProfileTabEmailsTable", _2 as "emptyPage" }
